import { sumBy } from "lodash";
import { Waiver } from "types";

export const getWaiverParticipantCount = (waivers: Waiver[] = []) => {
    return sumBy(waivers, (waiver) => waiver.participants?.length ?? 1);
};
